/**
 * @generated SignedSource<<0c7f68c3a8234b8dc241a7f692ddd824>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BoundedStakingOverviewQuery$variables = {
  assetId: string;
};
export type BoundedStakingOverviewQuery$data = {
  readonly bondedStakingOverview: {
    readonly __typename: "BondedStakingOverview";
    readonly items: ReadonlyArray<{
      readonly asset: {
        readonly name: string | null | undefined;
      };
      readonly items: ReadonlyArray<{
        readonly assetAmount: PrecisionFloat;
        readonly createdAt: TimeScalar | null | undefined;
        readonly fiatAmount: PrecisionFloat;
        readonly releaseDate: TimeScalar | null | undefined;
      }> | null | undefined;
    }> | null | undefined;
    readonly totalBondedFiat: PrecisionFloat | null | undefined;
  } | null | undefined;
};
export type BoundedStakingOverviewQuery = {
  response: BoundedStakingOverviewQuery$data;
  variables: BoundedStakingOverviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "assetId"
  }
],
v1 = [
  {
    "fields": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "assetIds.0",
            "variableName": "assetId"
          }
        ],
        "kind": "ListValue",
        "name": "assetIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalBondedFiat",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "BondedStakingOverviewAssetItem",
  "kind": "LinkedField",
  "name": "items",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "assetAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fiatAmount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "releaseDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BoundedStakingOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BondedStakingOverview",
        "kind": "LinkedField",
        "name": "bondedStakingOverview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BondedStakingOverviewItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BoundedStakingOverviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BondedStakingOverview",
        "kind": "LinkedField",
        "name": "bondedStakingOverview",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BondedStakingOverviewItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aff18d9c84d273d02b5d6328d4f8bc01",
    "id": null,
    "metadata": {},
    "name": "BoundedStakingOverviewQuery",
    "operationKind": "query",
    "text": "query BoundedStakingOverviewQuery(\n  $assetId: ID!\n) {\n  bondedStakingOverview(input: {assetIds: [$assetId]}) {\n    __typename\n    totalBondedFiat\n    items {\n      items {\n        assetAmount\n        fiatAmount\n        releaseDate\n        createdAt\n      }\n      asset {\n        __typename\n        name\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "72d0cc3d0ce28fa5f296db6bbe5135f7";

export default node;
